/*
 * Copyright (c) 2023 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import ConfirmModal, {
  ConfirmModalProps
} from '../../../../client/js/components/modals/ConfirmModal'

function UseMandateInfoModal (props: Omit<ConfirmModalProps, 'message'>) {
  const { onClose, onConfirm, ...others } = props
  const intl = useIntl()
  return (
    <ConfirmModal
      centered
      {...others}
      onClose={onClose}
      onConfirm={onConfirm}
      message={(
        <>
          <p>
            {intl.formatMessage({
              id: 'do_you_want_to_use_mandate_info',
              defaultMessage: 'Voulez-vous utiliser les informations du mandat ?'
            })}
          </p>
          <ul>
            <li>
              {intl.formatMessage({
                id: 'management',
                defaultMessage: 'Gestion'
              })}
            </li>
            <li>
              {intl.formatMessage({
                id: 'rent',
                defaultMessage: 'Loyer'
              })}
            </li>
            <li>
              {intl.formatMessage({
                id: 'security_deposit',
                defaultMessage: 'Dépôt de garantie'
              })}
            </li>
            <li>
              {intl.formatMessage({
                id: 'agency_fees',
                defaultMessage: 'Honoraires de location'
              })}
            </li>
            <li>
              {intl.formatMessage({
                id: 'management_fees',
                defaultMessage: 'Honoraires de gestion'
              })}
            </li>
          </ul>
        </>
      )}
    />
  )
}

export default UseMandateInfoModal
